import { useContext } from "react";
import { authContext } from "../context/AuthContext";

export default function useCompanyType(){
    const {auth} = useContext(authContext)

    //console.log(auth)

    if(auth.data.company.id === 2){
        return "colombia";
    }else{
        return "mexico";
    }
}